module.exports = __webpack_public_path__ + "media/index/vm-art-c4bb9f1b.png";